import { TAxisOptions } from '../types/types';

const xAxis: TAxisOptions[] = [
  {
    title: {
      text: '',
    },
    visible: true,
    type: 'datetime',
    lineWidth: 1,
    lineColor: '#DEE0E3',
    labels: {
      enabled: false,
    },
    showFirstLabel: true,
    showLastLabel: false,
    tickLength: 0,
    plotBands: [],
  },
  {
    title: {
      text: '',
    },
    showFirstLabel: false,
    showLastLabel: false,
    visible: true,
    type: 'datetime',
    lineWidth: 1,
    labels: {
      enabled: false,
    },
    tickLength: 0,
  },
];

const yAxis: TAxisOptions[] = [
  {
    title: {
      text: '',
    },
    tickPixelInterval: 30,
    gridLineDashStyle: 'Dash',
    visible: true,
    showFirstLabel: false,
    showLastLabel: false,
    opposite: false,
    min: undefined,
    max: undefined,
    tickInterval: undefined,
  },
  {
    title: {
      text: '',
    },
    tickPixelInterval: 30,
    gridLineDashStyle: 'Dash',
    visible: true,
    showFirstLabel: false,
    showLastLabel: false,
    opposite: true,
  },
];

export const staticChartStyleOption = {
  title: {
    text: null,
  },
  xAxis,
  yAxis,
  tooltip: {
    crosshairs: [{
      width: 1,
      color: '#FF8C00',
      dashStyle: 'Dash',
    }],
    backgroundColor: '#ffffff',
    borderRadius: 0,
    borderColor: '#AAAAAA',
    borderWidth: 2,
    useHTML: true,
    shared: true,
    shadow: false,
    valueDecimals: 2,
  },

  chart: {
    // Do we need this for react highcharts?
    // renderTo: this.el,
    spacingTop: 0,
    spacingLeft: 0,
    spacingRight: 0,
    spacingBottom: 5,
    height: 235,
  },

  legend: {
    enabled: false,
  },

  credits: {
    enabled: false,
  },
};
